module.exports = __webpack_public_path__ + "static/media/xray-training-medial-flex1.1bff6351.png";